import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import FRONTEND_CONFIG from "./frontend_config";

export default function ExamDashboard() {
  const [exams, setExams] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  const [confirmMessage, setConfirmMessage] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);

  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    class: "",
    subject: "",
    duration: "",
    totalMarks: "",
  });

  const navigate = useNavigate();
  const EXAM_API = `${FRONTEND_CONFIG.API_URL}/api/exams`;

  const fetchExams = async () => {
    try {
      const res = await axios.get(`${EXAM_API}/allexam`);
      setExams(res.data);
    } catch (err) {
      showCustomAlert("Error fetching exams.");
    }
  };

  useEffect(() => {
    fetchExams();
  }, []);

  const showCustomAlert = (message) => {
    setAlertMessage(message);
    setShowAlert(true);
  };

  const showConfirmDialog = (message, action) => {
    setConfirmMessage(message);
    setConfirmAction(() => action);
    setShowConfirm(true);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCreateExam = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${EXAM_API}/create`, formData);
      setShowForm(false);
      setFormData({
        title: "",
        class: "",
        subject: "",
        duration: "",
        totalMarks: "",
      });
      fetchExams();
      showCustomAlert("Exam created successfully!");
    } catch (err) {
      showCustomAlert("Error creating exam.");
    }
  };

  const handleDeleteExam = async (examId) => {
    showConfirmDialog("Are you sure you want to delete this exam?", async () => {
      try {
        await axios.delete(`${EXAM_API}/delete/${examId}`);
        fetchExams();
        showCustomAlert("Exam deleted successfully!");
      } catch (error) {
        showCustomAlert("Failed to delete exam.");
      }
    });
  };

  const filteredExams = exams.filter((exam) =>
    exam.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleViewQuestionSet = async (examId) => {
    try {
      const response = await axios.get(
        `${FRONTEND_CONFIG.API_URL}/api/questionset/exam/${examId}`
      );

      if (response.data.length > 0) {
        navigate(`/view-question-sets/${examId}`);
      } else {
        showCustomAlert("⚠️ No question sets found for this exam.");
      }
    } catch (error) {
      showCustomAlert("Error fetching question sets. Please try again.");
    }
  };

  const handleCreateQuestionSet = (exam) => {
    localStorage.setItem("selectedExam", JSON.stringify(exam));
    navigate("/createquestion-set", { state: { exam } });
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.header}>Exam Dashboard</h1>

      <div style={styles.topBar}>
        <input
          type="text"
          placeholder="Search exam..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={styles.searchInput}
        />
        <button onClick={() => setShowForm(true)} style={styles.newBtn}>
          + New Exam
        </button>
      </div>

      {filteredExams.length === 0 ? (
        <p style={{ textAlign: "center", color: "#777" }}>No exams found.</p>
      ) : (
        <table style={styles.table}>
          <thead>
            <tr style={styles.tableHeadRow}>
              <th style={styles.th}>Title</th>
              <th style={styles.th}>Class</th>
              <th style={styles.th}>Subject</th>
              <th style={styles.th}>Duration</th>
              <th style={styles.th}>Total Marks</th>
              <th style={styles.th}>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredExams.map((exam) => (
              <tr key={exam._id} style={styles.tr}>
                <td style={styles.td}>{exam.title}</td>
                <td style={styles.td}>{exam.class}</td>
                <td style={styles.td}>{exam.subject}</td>
                <td style={styles.td}>{exam.duration} min</td>
                <td style={styles.td}>{exam.totalMarks}</td>
                <td style={styles.td}>
                  <button
                    onClick={() => handleCreateQuestionSet(exam)}
                    style={styles.addQuesBtn}
                  >
                    ➕ Create Question Set
                  </button>

                  <Link
                    to={`/exam/${exam._id}/question-sets`}
                    className="bg-indigo-600 text-white px-3 py-2 rounded-md hover:bg-indigo-700"
                  >
                    View Question Sets
                  </Link>

                  <button
                    onClick={() => handleDeleteExam(exam._id)}
                    style={{
                      background: "red",
                      color: "#fff",
                      border: "none",
                      padding: "6px 10px",
                      borderRadius: "5px",
                      cursor: "pointer",
                      marginLeft: "10px",
                    }}
                  >
                    ❌
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* ---------- Create Exam Form Modal ---------- */}
      {showForm && (
        <div style={styles.overlay}>
          <div style={styles.formCard}>
            <h2>Create New Exam</h2>
            <form onSubmit={handleCreateExam} style={styles.form}>
              <input name="title" placeholder="Exam Title" value={formData.title} onChange={handleChange} required style={styles.input} />
              <input name="class" placeholder="Class" value={formData.class} onChange={handleChange} required style={styles.input} />
              <input name="subject" placeholder="Subject" value={formData.subject} onChange={handleChange} required style={styles.input} />
              <input name="duration" type="number" placeholder="Duration (in minutes)" value={formData.duration} onChange={handleChange} required style={styles.input} />
              <input name="totalMarks" type="number" placeholder="Total Marks" value={formData.totalMarks} onChange={handleChange} required style={styles.input} />

              <div style={styles.buttonGroup}>
                <button type="submit" style={styles.saveBtn}>Save</button>
                <button type="button" onClick={() => setShowForm(false)} style={styles.cancelBtn}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ---------- Custom Alert Modal ---------- */}
      {showAlert && (
        <div style={alertStyles.overlay}>
          <div style={alertStyles.card}>
            <p style={alertStyles.message}>{alertMessage}</p>
            <button style={alertStyles.okBtn} onClick={() => setShowAlert(false)}>OK</button>
          </div>
        </div>
      )}

      {/* ---------- Confirm YES / NO Modal ---------- */}
      {showConfirm && (
        <div style={alertStyles.overlay}>
          <div style={alertStyles.card}>
            <p style={alertStyles.message}>{confirmMessage}</p>
            <div style={{ display: "flex", gap: "10px", marginTop: "15px" }}>
              <button
                style={alertStyles.okBtn}
                onClick={() => { setShowConfirm(false); confirmAction(); }}
              >
                Yes
              </button>
              <button
                style={alertStyles.cancelBtn}
                onClick={() => setShowConfirm(false)}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

/* ---------------- Styles ---------------- */

const alertStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backdropFilter: "blur(3px)",
  },
  card: {
    background: "#fff",
    padding: "25px",
    borderRadius: "10px",
    width: "350px",
    textAlign: "center",
    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
    animation: "fadeIn 0.2s ease",
  },
  message: {
    fontSize: "18px",
    marginBottom: "15px",
  },
  okBtn: {
    padding: "10px 25px",
    background: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
  cancelBtn: {
    padding: "10px 25px",
    background: "gray",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
};

const styles = {
  container: { padding: "40px", fontFamily: "Arial, sans-serif" },
  header: { textAlign: "center", marginBottom: "20px", fontSize: "26px", fontWeight: "bold" },
  topBar: { display: "flex", justifyContent: "space-between", marginBottom: "20px" },
  searchInput: { width: "70%", padding: "10px", borderRadius: "5px", border: "1px solid #ccc" },
  newBtn: { background: "#28a745", color: "#fff", border: "none", padding: "10px 20px", borderRadius: "5px", cursor: "pointer" },
  table: { width: "100%", borderCollapse: "collapse", border: "1px solid #ddd", backgroundColor: "#fff", boxShadow: "0 2px 5px rgba(0,0,0,0.1)" },
  tableHeadRow: { backgroundColor: "#007bff", color: "#fff" },
  th: { padding: "10px", border: "1px solid #ddd" },
  tr: { textAlign: "center" },
  td: { padding: "10px", border: "1px solid #ddd" },
  addQuesBtn: { background: "#ff9800", color: "#fff", border: "none", padding: "6px 10px", borderRadius: "5px", cursor: "pointer", fontWeight: "bold", marginRight: "10px" },
  overlay: { position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "center" },
  formCard: { background: "#fff", padding: "30px", borderRadius: "10px", boxShadow: "0 0 10px rgba(0,0,0,0.2)", width: "400px" },
  form: { display: "flex", flexDirection: "column" },
  input: { marginBottom: "10px", padding: "10px", borderRadius: "5px", border: "1px solid #ccc" },
  buttonGroup: { display: "flex", justifyContent: "space-between" },
  saveBtn: { background: "#007bff", color: "#fff", border: "none", padding: "10px 20px", borderRadius: "5px", cursor: "pointer" },
  cancelBtn: { background: "#ccc", border: "none", padding: "10px 20px", borderRadius: "5px", cursor: "pointer" },
};

